import { useFormContext } from "react-hook-form";
import { useDataTableQuery } from "./useDataTableQuery";

const useBusy = () => {
  const dataTableQuery = useDataTableQuery();
  const isFetching = dataTableQuery?.query?.isFetching ?? false;
  const isPending = dataTableQuery?.isPending ?? false;
  const form = useFormContext();
  if (form) {
    return isFetching || form.formState.isSubmitting || isPending;
  }
  return isFetching || isPending;
};

export default useBusy;
